import styled from 'styled-components';
import { PaginationListMixin } from '../../mixins/components/PaginationListMixin';

/**
 * Used by the `Pagination` component as a parent for the buttons and readout text.
 *
 * @since 8.0.0
 */
var PaginationList = /*#__PURE__*/styled.ul.withConfig({
  displayName: "PaginationList",
  componentId: "c11n-8-101-0__sc-1b5xve1-0"
})(["", ""], PaginationListMixin);
PaginationList.displayName = 'PaginationList';

/** @component */
export { PaginationList };